import { Button, HFlow, Modal, ModalBody, ModalFooter, ModalHeader, Text, VFlow } from 'bold-ui'
import { SubmitButton } from 'components/form'
import { ServicosCertificadoEnum } from 'graphql/types.generated'

type ServicosSelecionadosProps = {
  servicosSelecionados: ReadonlyArray<ServicosCertificadoEnum>
  servicosValidados: ReadonlyArray<ServicosCertificadoEnum>
  isModalOpen: boolean
  handleModalClose(): void
  handleModalSubmit(): void
  loading: boolean
}

export function ServicosSelecionadosConfirmacaoModal({
  servicosSelecionados,
  servicosValidados,
  isModalOpen,
  handleModalClose,
  handleModalSubmit,
  loading,
}: ServicosSelecionadosProps) {
  const rndsChecked = servicosSelecionados?.includes(ServicosCertificadoEnum.RNDS)
  const cadsusChecked = servicosSelecionados?.includes(ServicosCertificadoEnum.CADSUS)
  const pdmChecked = servicosSelecionados?.includes(ServicosCertificadoEnum.PDM)
  const rndsValidated = servicosValidados?.includes(ServicosCertificadoEnum.RNDS)
  const cadsusValidated = servicosValidados?.includes(ServicosCertificadoEnum.CADSUS)
  const pdmValidated = servicosValidados?.includes(ServicosCertificadoEnum.PDM)

  return (
    <Modal open={isModalOpen} onClose={handleModalClose} size='small'>
      <ModalHeader
        title='Serviços selecionados diferentes do certificado'
        icon={{ name: 'exclamationTriangleOutline', fill: 'alert' }}
      />
      <ModalBody>
        <HFlow>
          <VFlow vSpacing={0}>
            <Text>
              Serviços selecionados: {rndsChecked && 'RNDS'}
              {rndsChecked && cadsusChecked && ','} {cadsusChecked && 'CADSUS'}
              {(rndsChecked || cadsusChecked) && ','} {pdmChecked && 'PDM'}
            </Text>
            <Text>
              Serviços vinculados no certificado: {rndsValidated && 'RNDS'}
              {rndsValidated && cadsusValidated && ','} {cadsusValidated && 'CADSUS'}
              {(rndsValidated || cadsusValidated) && ','} {pdmValidated && 'PDM'}
            </Text>
            <Text>Deseja continuar?</Text>
          </VFlow>
        </HFlow>
      </ModalBody>
      <ModalFooter>
        <HFlow justifyContent='flex-end'>
          <Button size='medium' onClick={handleModalClose}>
            Cancelar
          </Button>
          <SubmitButton
            kind='primary'
            skin='default'
            size='medium'
            handleSubmit={handleModalSubmit}
            disabled={loading}
            loading={loading}
          >
            Continuar
          </SubmitButton>
        </HFlow>
      </ModalFooter>
    </Modal>
  )
}
